import { Controller } from 'react-hook-form';
import { Column, RichTextEditor, Text } from '~/commonComponents';
import { jobDescriptionMinLength } from '~/components/PermanentJobsV2/utils';
import { IBaseFormProps } from '../../Types';

export const JobDescriptionForm = ({ control, errors }: IBaseFormProps) => {
  return (
    <Column gap={6}>
      <Controller
        control={control}
        name="jobDescription"
        render={({ field }) => (
          <RichTextEditor
            value={field.value}
            onChange={field.onChange}
            height={350}
            htmlPlaceholder="<b>Overview</b><br/>Give an overview of the job and general expectations.<br/><br/><b>Responsibilities</b><ul><li>Outline what kinds of responsibilities/tasks will be required from the role.</li></ul><br/><b>Why Work with Us?</b><br/>Talk about what makes your office a great place to work!"
            isError={!!errors?.jobDescription}
          />
        )}
      />
      <Text color="neutral_500" italic>
        {jobDescriptionMinLength} Character Min
      </Text>
    </Column>
  );
};
